import Box, { BoxProps } from '@mui/material/Box';
import { alpha, styled } from '@mui/material/styles';
import { PaletteColor, Theme } from '@mui/material';

interface OwnerState {
    color: keyof Theme['palette'] | 'default',
    variant: 'filled' | 'outlined' | 'soft';
}

interface StyledLabelProps extends BoxProps {

    ownerState: OwnerState
}

export const StyledLabel = styled(Box)<StyledLabelProps>(({ theme, ownerState }) => {
    // Define a type guard to check if a palette color is a PaletteColor object
  const isPaletteColor = (color: any): color is PaletteColor => {
    return color && typeof color === 'object' && 'main' in color && 'contrastText' in color;
  };
  const lightMode = theme.palette.mode === 'light';

  const filledVariant = ownerState.variant === 'filled';

  const outlinedVariant = ownerState.variant === 'outlined';

  const softVariant = ownerState.variant === 'soft';

  const defaultStyle = {
    ...(ownerState.color === 'default' && {
      // FILLED
      ...(filledVariant && {
        color: lightMode ? theme.palette.common.white : theme.palette.grey[800],
        backgroundColor: theme.palette.text.primary,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        border: `2px solid ${theme.palette.text.primary}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette.text.secondary,
        backgroundColor: alpha(theme.palette.grey[500], 0.16),
      }),
    }),
  };


  let colorStyle = {};

  if (ownerState.color !== 'default') {
    const paletteColor = theme.palette[ownerState.color];

    if (isPaletteColor(paletteColor)) {
      colorStyle = {
        ...(filledVariant && {
          color: paletteColor.contrastText,
          backgroundColor: paletteColor.main,
        }),
        ...(outlinedVariant && {
          backgroundColor: 'transparent',
          color: paletteColor.main,
          border: `2px solid ${paletteColor.main}`,
        }),
        ...(softVariant && {
          color: lightMode ? paletteColor.dark : paletteColor.light,
          backgroundColor: alpha(paletteColor.main, 0.16),
        }),
      };
    }
  }

  return {
    height: 24,
    minWidth: 24,
    lineHeight: 0,
    borderRadius: 6,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    textTransform: 'capitalize',
    padding: theme.spacing(0, 0.75),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shorter,
    }),
    ...defaultStyle,
    ...colorStyle,
  };
});
